<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper new-wrapper">
    <div class="card shadow-sm">
        <div class="card-header bg-white border-0">
            <div class="header-top">
                <div class="title-block">
                    <h2 class="mb-1"><i class="fa fa-users me-2"></i>ข้อมูลประมาณการอ้อยคงเหลือปีการผลิค 68/69</h2>
                    <p class="subtitle">อัปเดตจากฐานข้อมูล {{year_n}}</p>
                </div>
                <div class="header-actions">
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="LoadCaneby();">
                        <i class="fas fa-sync me-1"></i>รีเฟรชข้อมูล
                    </button>
                </div>
            </div>

            <div class="summary-grid" *ngIf="sumlast?.length">
                <ng-container *ngFor="let item of sumlast">
                    <div class="summary-card">
                        <p class="label">คาดการปริมาณอ้อย</p>
                        <h4>{{item.left_incaneinAll+item.caneinAllf | number}}</h4>
                        <span class="muted">ผลผลิต {{((item.left_incaneinAll+item.caneinAllf)/item.areaAll) | number:'1.0-2'}} ตัน/ไร่</span>
                    </div>
                    <div class="summary-card">
                        <p class="label">% +-ปัจจุบัน</p>
                        <h4 class="text-info">{{item.pc_difcaneinAllf | number:'1.0-2'}} %</h4>
                        <span class="muted">% +-7วันล่าสุด {{item.pc_incaneinAll | number:'1.0-2'}} %</span>
                    </div>
                    <div class="summary-card">
                        <p class="label">คาดการอ้อยคงเหลือ</p>
                        <h4>{{item.left_incaneinAll | number}}</h4>
                        <span class="muted">อ้อยเข้าหีบ {{item.caneinAll | number}}</span>
                    </div>
                    <div class="summary-card">
                        <p class="label">ผลผลิตเฉลี่ย</p>
                        <h4>{{item.yield_allf | number:'1.0-2'}}</h4>
                        <span class="muted">อ้อยเข้าหีบ (ตัดเสร็จ) {{item.caneinAllf | number}}</span>
                    </div>
                    <div class="summary-card">
                        <p class="label">พื้นที่ตัดเสร็จ</p>
                        <h4>{{item.areaAllf | number}}</h4>
                        <span class="muted">% พื้นที่ตัดเสร็จ {{(item.areaAllf*100/item.areaAll) | number:'1.0-2'}}%</span>
                    </div>
                    <div class="summary-card">
                        <p class="label">แปลงตัดเสร็จ</p>
                        <h4>{{item.cntStf | number}}</h4>
                        <span class="muted">% แปลงตัดเสร็จ {{(item.cntStf*100/item.cnt_all) | number:'1.0-2'}}%</span>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="card-body pt-0">
            <div class="toolbar" *ngIf="filterbyzone != null">
                <div class="toolbar-left">
                    <button class="btn btn-primary btn-sm" (click)="ExportExcel();"> <i class="fas fa-download me-2"></i>
                        Download Excel</button>
                </div>

                <div class="toolbar-tabs">
                    <ul class="nav nav-pills" id="vert-tabs-tab" role="tablist" aria-orientation="horizontal">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="numdex===1" id="tabs-tab1" (click)="setDataTeble(1);"
                                data-toggle="pill">สรุปอ้อยคงเหลือ</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="numdex===4" id="tabs-tab2" (click)="setDataTeble(4);"
                                data-toggle="pill">%อ้อยบวกลบ</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="numdex===3" id="tabs-tab3" (click)="setDataTeble(3);"
                                data-toggle="pill">ปริมาณอ้อยและตัดพันธุ์</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [class.active]="numdex===2" id="tabs-tab4" (click)="setDataTeble(2);"
                                data-toggle="pill">ข้อมูลพื้นที่</a>
                        </li>
                    </ul>
                </div>

                <div class="toolbar-right" *ngIf="filterbyzone != null" [formGroup]="Pergroup">
                    <span class="input-group-text">เลือกโซน/ส่วน</span>
                    <select class="form-select" formControlName="szone" (change)="Selectbyzone();">
                        <option value="" disabled>-- กรุณาเลือก --</option>
                        <option value="0">All | ข้อมูลทุกโซน</option>
                        <option value="P1">P1 | ข้อมูลส่วนที่ 1</option>
                        <option value="P2">P2 | ข้อมูลส่วนที่ 2</option>
                        <option value="P3">P3 | ข้อมูลส่วนที่ 3</option>
                        <option value="P4">P4 | ข้อมูลส่วนที่ 4</option>
                        <option value="P5">P5 | ข้อมูลส่วนที่ 5</option>
                        <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}} | {{item.ZONENAME}}</option>
                    </select>
                </div>
            </div>

            <div class="table-wrapper table-responsive p-2">
                <table *ngIf="numdex==1" class="table table-hover table-bordered table-sm table-sticky" #table>
                    <thead>
                        <tr class="text-center headText">
                            <th scope="col" colspan="4"></th>
                            <!--<th scope="col" colspan="5">อ้อยคงเหลือ08/02/66</th>-->
                            <th scope="col" colspan="5">ปริมาณอ้อยคงเหลือ</th>
                            <th scope="col" colspan="4">อ้อยเข้า</th>
                        </tr>
                        <tr class="text-center">
                            <th>ส่วน</th>
                            <th>โซน</th>
                            <th>รหัส</th>
                            <th>ชื่อ</th>

                            <!--<th style="color:rgb(111, 210, 111);">รวม</th>
                            <th style="color:rgb(111, 210, 111);">อ้อยER</th>  
                            <th style="color:rgb(111, 210, 111);">อ้อยSR</th>
                            <th style="color:rgb(111, 210, 111);">อ้อยST</th>  
                            <th style="color:rgb(111, 210, 111);">อ้อยCL</th>-->

                            <th style="color:rgb(224, 187, 255);">รวม</th>
                            <th style="color:rgb(224, 187, 255);">อ้อยER</th>
                            <th style="color:rgb(224, 187, 255);">อ้อยSR</th>
                            <th style="color:rgb(224, 187, 255);">อ้อยST</th>
                            <th style="color:rgb(224, 187, 255);">อ้อยCL</th>

                            <th>ประเมินอ้อย</th>
                            <th>อ้อยเข้ารวม</th>
                            <th>ตัดเสร็จ</th>
                            <th>คาดการ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!---->
                        <tr *ngFor="let item of filterbyzone" [ngStyle]="{'background-color':(item.Codename.substr(0,3) == '*รว') ? '#fde9db' :
                                                       (item.Codename.substr(0,3) == '**ร') ? '#fce08c' :
                                                       (item.Codename.substr(0,3) == '***') ? '#8dc9ff' : null }">
                            <td>{{item.Partcode}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.Code}}</td>
                            <td>{{item.Codename}}</td>

                            <!--<td class="text-right"> {{item.canein2All | number}}</td>
                            <td class="text-right"> {{item.canein2Er | number}}</td>
                            <td class="text-right"> {{item.canein2Sr | number}}</td>
                            <td class="text-right"> {{item.canein2St | number}}</td>
                            <td class="text-right"> {{item.canein2Cl | number}}</td>      -->

                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinAll > 0) ? 'green' :(item.pc_incaneinAll == 0 ) ? 'orange' :(item.pc_incaneinAll < 0) ? 'red' : null }">
                                {{item.left_incaneinAll | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinEr > 0) ? 'green' :(item.pc_incaneinEr == 0 ) ? 'orange' :(item.pc_incaneinEr < 0) ? 'red' : null }">
                                {{item.left_incaneinEr | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinSr > 0) ? 'green' :(item.pc_incaneinSr == 0 ) ? 'orange' :(item.pc_incaneinSr < 0) ? 'red' : null }">
                                {{item.left_incaneinSr | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinSt > 0) ? 'green' :(item.pc_incaneinSt == 0 ) ? 'orange' :(item.pc_incaneinSt < 0) ? 'red' : null }">
                                {{item.left_incaneinSt | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinCl > 0) ? 'green' :(item.pc_incaneinCl == 0 ) ? 'orange' :(item.pc_incaneinCl < 0) ? 'red' : null }">
                                {{item.left_incaneinCl | number}}</td>

                            <td class="text-right">{{item.AssessAll | number}}</td>
                            <td class="text-right">{{item.caneinAll | number}}</td>
                            <td class="text-right">{{item.caneinAllf |number}}</td>
                            <td class="text-right" [ngClass]="item.left_incaneinAll+item.caneinAllf >= item.AssessAll ? 'bg-success': '' 
                                || item.left_incaneinAll+item.caneinAllf < item.AssessAll ? 'bg-danger' :''">
                                {{item.left_incaneinAll+item.caneinAllf | number}}</td>
                        </tr>
                    </tbody>
                </table>

                <table *ngIf="numdex==4" class="table table-hover table-bordered table-sm table-sticky" #table>
                    <thead>
                        <tr class="text-center">
                            <th scope="col" colspan="4"></th>
                            <!--<th scope="col" colspan="5" style="color:rgb(94, 200, 94);">%+-อ้อยคงเหลือ08/02/66</th>-->
                            <th scope="col" colspan="5" style="color:rgb(200, 140, 250);">%+-อ้อยเข้าปัจจุบัน</th>
                            <th scope="col" colspan="5" style="color:rgb(116, 211, 255);">%+-อ้อยเข้า7วันล่าสุด</th>
                            <th scope="col" colspan="2">จำนวนแปลง</th>
                        </tr>
                        <tr class="text-center">
                            <th>ส่วน</th>
                            <th>โซน</th>
                            <th>รหัส</th>
                            <th>ชื่อ</th>
                            <!--<th style="color:rgb(111, 210, 111);">%+-รวม</th>
                            <th style="color:rgb(111, 210, 111);">%+-ER</th>
                            <th style="color:rgb(111, 210, 111);">%+-SR</th>
                            <th style="color:rgb(111, 210, 111);">%+-ST</th>
                            <th style="color:rgb(111, 210, 111);">%+-CL</th>-->
                            <th style="color:rgb(224, 187, 255);">%+-รวม</th>
                            <th style="color:rgb(224, 187, 255);">%+-ER</th>
                            <th style="color:rgb(224, 187, 255);">%+-SR</th>
                            <th style="color:rgb(224, 187, 255);">%+-ST</th>
                            <th style="color:rgb(224, 187, 255);">%+-CL</th>
                            <th style="color:rgb(139, 214, 248);">%+-รวม</th>
                            <th style="color:rgb(139, 214, 248);">%+-ER</th>
                            <th style="color:rgb(139, 214, 248);">%+-SR</th>
                            <th style="color:rgb(139, 214, 248);">%+-ST</th>
                            <th style="color:rgb(139, 214, 248);">%+-CL</th>
                            <th style="color:green;">>+20%</th>
                            <th style="color:red;"><-20%< /th>
                        </tr>
                    </thead>
                    <tbody>
                        <!---->
                        <tr *ngFor="let item of filterbyzone" [ngStyle]="{'background-color':
                            (item.Codename.substr(0,3) == '*รว') ? '#fde9db' :
                            (item.Codename.substr(0,3) == '**ร') ? '#fce08c' :
                            (item.Codename.substr(0,3) == '***') ? '#8dc9ff' : null }">
                            <td>{{item.Partcode}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.Code}}</td>
                            <td>{{item.Codename}}</td>

                            <!--
                                <td class="text-right"
                                [ngStyle]="{'color':(item.pc_canein2All > 0) ? 'green' :(item.pc_canein2All == 0 ) ? 'orange' :(item.pc_canein2All < 0) ? 'red' : null }">
                                {{item.pc_canein2All | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_canein2Er > 0) ? 'green' :(item.pc_canein2Er == 0 ) ? 'orange' :(item.pc_canein2Er < 0) ? 'red' : null }">
                                {{item.pc_canein2Er | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_canein2Sr > 0) ? 'green' :(item.pc_canein2Sr == 0 ) ? 'orange' :(item.pc_canein2Sr < 0) ? 'red' : null }">
                                {{item.pc_canein2Sr |number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_canein2St > 0) ? 'green' :(item.pc_canein2St == 0 ) ? 'orange' :(item.pc_canein2St < 0) ? 'red' : null }">
                                {{item.pc_canein2St | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_canein2Cl > 0) ? 'green' :(item.pc_canein2Cl == 0 ) ? 'orange' :(item.pc_canein2Cl < 0) ? 'red' : null }">
                                {{item.pc_canein2Cl | number}}</td>
                            -->

                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_difcaneinAllf > 0) ? 'green' :(item.pc_difcaneinAllf == 0 ) ? 'orange' :(item.pc_difcaneinAllf < 0) ? 'red' : null }">
                                {{item.pc_difcaneinAllf | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_difcaneinErf > 0) ? 'green' :(item.pc_difcaneinErf == 0 ) ? 'orange' :(item.pc_difcaneinErf < 0) ? 'red' : null }">
                                {{item.pc_difcaneinErf | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_difcaneinSrf > 0) ? 'green' :(item.pc_difcaneinSrf == 0 ) ? 'orange' :(item.pc_difcaneinSrf < 0) ? 'red' : null }">
                                {{item.pc_difcaneinSrf |number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_difcaneinStf > 0) ? 'green' :(item.pc_difcaneinStf == 0 ) ? 'orange' :(item.pc_difcaneinStf < 0) ? 'red' : null }">
                                {{item.pc_difcaneinStf | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_difcaneinClf > 0) ? 'green' :(item.pc_difcaneinClf == 0 ) ? 'orange' :(item.pc_difcaneinClf < 0) ? 'red' : null }">
                                {{item.pc_difcaneinClf | number}}</td>

                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinAll > 0) ? 'green' :(item.pc_incaneinAll == 0 ) ? 'orange' :(item.pc_incaneinAll < 0) ? 'red' : null }">
                                {{item.pc_incaneinAll | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinEr > 0) ? 'green' :(item.pc_incaneinEr == 0 ) ? 'orange' :(item.pc_incaneinEr < 0) ? 'red' : null }">
                                {{item.pc_incaneinEr | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinSr > 0) ? 'green' :(item.pc_incaneinSr == 0 ) ? 'orange' :(item.pc_incaneinSr < 0) ? 'red' : null }">
                                {{item.pc_incaneinSr | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinSt > 0) ? 'green' :(item.pc_incaneinSt == 0 ) ? 'orange' :(item.pc_incaneinSt < 0) ? 'red' : null }">
                                {{item.pc_incaneinSt | number}}</td>
                            <td class="text-right"
                                [ngStyle]="{'color':(item.pc_incaneinCl > 0) ? 'green' :(item.pc_incaneinCl == 0 ) ? 'orange' :(item.pc_incaneinCl < 0) ? 'red' : null }">
                                {{item.pc_incaneinCl | number}}</td>
                            <td class="text-right" style="color:green;">{{item.dif_p|number}}</td>
                            <td class="text-right" style="color:red;">{{item.dif_n|number}}</td>
                        </tr>
                    </tbody>
                </table>

                <table *ngIf="numdex==2" class="table table-hover table-bordered table-sm table-sticky" #table>
                    <thead>
                        <tr class="text-center">
                            <th scope="col" colspan="4"></th>
                            <th scope="col" colspan="2">จำนวนแปลง</th>
                            <th scope="col" colspan="2">แปลงER</th>
                            <th scope="col" colspan="2">แปลงSR</th>
                            <th scope="col" colspan="2">แปลงST</th>
                            <th scope="col" colspan="2">แปลงCL</th>

                            <th scope="col" colspan="2">รวมพื้นที่</th>
                            <th scope="col" colspan="2">พื้นที่ER</th>
                            <th scope="col" colspan="2">พื้นที่SR</th>
                            <th scope="col" colspan="2">พื้นที่ST</th>
                            <th scope="col" colspan="2">พื้นที่CL</th>
                        </tr>
                        <tr class="text-center">
                            <th>ส่วน</th>
                            <th>โซน</th>
                            <th>รหัส</th>
                            <th>ชื่อ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>

                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!---->
                        <tr *ngFor="let item of filterbyzone" [ngStyle]="{'background-color': 
                                (item.Codename.substr(0,3) == '*รว') ? '#fde9db' :
                                (item.Codename.substr(0,3) == '**ร') ? '#fce08c' :
                                (item.Codename.substr(0,3) == '***') ? '#8dc9ff' : null }">
                            <td>{{item.Partcode}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.Code}}</td>
                            <td>{{item.Codename}}</td>
                            <td class="text-right">{{item.cnt_all|number}}</td>
                            <td class="text-right">{{item.cntf|number}}</td>
                            <td class="text-right">{{item.cntEr|number}}</td>
                            <td class="text-right">{{item.cntErf|number}}</td>
                            <td class="text-right">{{item.cntSr|number}}</td>
                            <td class="text-right">{{item.cntSrf|number}}</td>
                            <td class="text-right">{{item.cntSt|number}}</td>
                            <td class="text-right">{{item.cntStf|number}}</td>
                            <td class="text-right">{{item.cntCl|number}}</td>
                            <td class="text-right">{{item.cntClf|number}}</td>

                            <td class="text-right">{{item.areaAll|number}}</td>
                            <td class="text-right">{{item.areaAllf|number}}</td>
                            <td class="text-right">{{item.areaEr|number}}</td>
                            <td class="text-right">{{item.areaErf|number}}</td>
                            <td class="text-right">{{item.areaSr|number}}</td>
                            <td class="text-right">{{item.areaSrf|number}}</td>
                            <td class="text-right">{{item.areaSt|number}}</td>
                            <td class="text-right">{{item.areaStf|number}}</td>
                            <td class="text-right">{{item.areaCl|number}}</td>
                            <td class="text-right">{{item.areaClf|number}}</td>

                        </tr>
                    </tbody>
                </table>

                <table *ngIf="numdex==3" class="table table-hover table-bordered table-sm table-sticky" #table>
                    <thead>
                        <tr class="text-center headText">
                            <th scope="col" colspan="4"></th>
                            <th scope="col" colspan="2">ปริมาณอ้อยรวม</th>
                            <th scope="col" colspan="2">ปริมาณอ้อยER</th>
                            <th scope="col" colspan="2">ปริมาณอ้อยSR</th>
                            <th scope="col" colspan="2">ปริมาณอ้อยST</th>
                            <th scope="col" colspan="2">ปริมาณอ้อยCL</th>

                            <th scope="col" colspan="2">ตัดพันธ์ุรวม</th>
                            <th scope="col" colspan="2">ตัดพันธ์ุER</th>
                            <th scope="col" colspan="2">ตัดพันธ์ุSR</th>
                            <th scope="col" colspan="2">ตัดพันธ์ุST</th>
                            <th scope="col" colspan="2">ตัดพันธ์ุCL</th>
                        </tr>
                        <tr class="text-center">
                            <th>ส่วน</th>
                            <th>โซน</th>
                            <th>รหัส</th>
                            <th>ชื่อ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>

                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                            <th>ทั้งหมด</th>
                            <th>ตัดเสร็จ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!---->
                        <tr *ngFor="let item of filterbyzone" [ngStyle]="{'background-color': 
                                (item.Codename.substr(0,3) == '*รว') ? '#fde9db' :
                                (item.Codename.substr(0,3) == '**ร') ? '#fce08c' :
                                (item.Codename.substr(0,3) == '***') ? '#8dc9ff' : null }">
                            <td>{{item.Partcode}}</td>
                            <td>{{item.supzone}}</td>
                            <td>{{item.Code}}</td>
                            <td>{{item.Codename}}</td>
                            <td class="text-right">{{item.AssessAll|number}}</td>
                            <td class="text-right">{{item.AssessAllf|number}}</td>
                            <td class="text-right">{{item.AssessEr|number}}</td>
                            <td class="text-right">{{item.AssessErf|number}}</td>
                            <td class="text-right">{{item.AssessSr|number}}</td>
                            <td class="text-right">{{item.AssessSrf|number}}</td>
                            <td class="text-right">{{item.AssessSt|number}}</td>
                            <td class="text-right">{{item.AssessStf|number}}</td>
                            <td class="text-right">{{item.AssessCl|number}}</td>
                            <td class="text-right">{{item.AssessClf|number}}</td>

                            <td class="text-right">{{item.SeedAll|number}}</td>
                            <td class="text-right">{{item.SeedAllf|number}}</td>
                            <td class="text-right">{{item.SeedEr|number}}</td>
                            <td class="text-right">{{item.SeedErf|number}}</td>
                            <td class="text-right">{{item.SeedSr|number}}</td>
                            <td class="text-right">{{item.SeedSrf|number}}</td>
                            <td class="text-right">{{item.SeedSt|number}}</td>
                            <td class="text-right">{{item.SeedStf|number}}</td>
                            <td class="text-right">{{item.SeedCl|number}}</td>
                            <td class="text-right">{{item.SeedClf|number}}</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>